// gatsby-browser.ts is used for non-jsx browser APIs.
// For browser APIs that require React, delete this file and create a gatsby-browser.tsx file. See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/#how-to-use-gatsby-browser-js
// You can see which APIs are used by viewing the cache file: .cache/api-runner-browser-plugins.js
import { GatsbyBrowser } from "gatsby";


const sitkaFeedbackEmbedScript = `
(function (s, i, t, k, a) {
    s.si = s.si || function () { (s.si.q = s.si.q || []).push(arguments) };
    s._Settings = { id: 1081 };
    k = i.getElementsByTagName('head')[0];
    a = i.createElement('script');
    a.async = 1;
    a.src = t + s._Settings.id;
    k.appendChild(a);
})(window, document, 'https://dashboard.sitkainsights.com/feedback/embed/?id=');
`;

const injectSitkaScript = (location: Location) => {

    if (location.pathname === "/") {
        return;
    }

    const embedContainer = document.getElementById("sitka-feedback-embed");

    // Only initialize when the target container exists on the current route.
    if (!embedContainer) {
        return;
    }

    if (document.getElementById("sitka-feedback-embed-inline-script")) {
        // The inline bootstrap script may only run once, so re-insert it when
        // navigating with Gatsby Link to ensure the embed initializes.
        document.getElementById("sitka-feedback-embed-inline-script")?.remove();
    }

    // Prevent duplicate render attempts if Sitka already populated the container.
    if (embedContainer.childElementCount > 0) {
        return;
    }

    const script = document.createElement("script");
    script.id = "sitka-feedback-embed-inline-script";
    script.innerHTML = sitkaFeedbackEmbedScript;
    document.head.appendChild(script);
};

export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {
    // Uncomment the following lines to test Rollbar error tracking
    // if (typeof window !== "undefined" && window.Rollbar) {
    //     window.Rollbar.error("Test error from Gatsby!");
    // }
};

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location }) => {
    // Other code can be added here and will run on all routes

    injectSitkaScript(location);
};

// Workaround for scroll issues when using Link component on Safari
// See: https://github.com/gatsbyjs/gatsby/issues/38201#issuecomment-1631378720
export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = ({
    prevRouterProps,
    routerProps: { location },
    pathname,
    getSavedScrollPosition,
}) => {
    const currentPosition = getSavedScrollPosition(location);

    setTimeout(() => {
        window.scrollTo(...(currentPosition || [0, 0]));
    }, 100);

    return false;
};

